import React from 'react';

import Layout from '../../components/Layout';
import NotFound from '../not-found/NotFound';
import Static from './Static';

import { addJavaHeaders, getCityIdsGetArray } from '../../utils';
import { getCityConfig, parseJSON } from '../../apiUtils';
import { setCity } from '../../actions/city';

// FIXME: getSeoData из '../../utils' подставляет лишний слэш в конце
async function getSeoData(fetch, page, city_ids = [78, 47]) {
	try {
		const seoRes = await fetch(`/lexsApi/seo?page=${page}&${getCityIdsGetArray(city_ids)}`);
		const response = await seoRes.json();
		return {
			title: response.metaTitle,
			description: response.metaDescription,
			keywords: response.metaKeywords,
		};
	} catch (e) {
		return {};
	}
}

async function action({ fetch, pathname: path, store, params }) {
	const {
		cityConfig,
		token: { token },
	} = store.getState();

	const city = setCity({
		store,
		params,
		fetch,
	});

	if (!cityConfig) {
		await getCityConfig(city.cityIds, {
			store,
			fetch,
		});
	}

	const slug = path.replace(/\//g, '');

	const { title, description, keywords } = await getSeoData(fetch, slug, city.cityIds);

	const PageNotFound = {
		chunks: ['not-found'],
		title: 'Страница не найдена',
		component: (
			<Layout isNotFound>
				<NotFound title={title} />
			</Layout>
		),
		status: 404,
	};

	const fetchUrl = '/lexsApi/content/static/item';
	const fetchOptions = {
		method: 'POST',
		...addJavaHeaders(token),
		body: JSON.stringify({
			slug,
		}),
	};

	let articleData;

	try {
		const articleRes = await fetch(fetchUrl, fetchOptions).then(parseJSON);

		if (articleRes.result === 'ok') {
			articleData = articleRes.data;
		} else {
			return PageNotFound;
		}
	} catch (e) {
		return PageNotFound;
	}

	return {
		chunks: ['static'],
		title,
		description,
		keywords,
		component: (
			<Layout route={slug}>
				<Static route={slug} article={articleData} />
			</Layout>
		),
	};
}

export default action;
